export const leaveApplications = `{ leaveApplications {
        id
        userId
        companyId
        leaveTypeId
        startDate
        endDate
        resumptionDate
        isActive
        status
        statusDescription
        genderId
        branchId
        regionId
        gender
        leaveType
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
        }`;
export const allPolicies = `{  allPolicies {
        id
        companyId
        leaveTypeId
        leaveType
        gender
        acrues
        isActive
        accrualRate
        accrualDate
        canCarryForward
        maxDaysCarryForward
        maxOpenApplications
        createdDate
        createdBy
        updatedDate
        updatedBy
        maxDays
    }
        }`;
export const allPoliciesView = `{
  allPolicyViews {
    id
    companyId
    leaveTypeId
    leaveType
    gender
    acrues
    accrualRate
    maxDaysCarryForward
    canCarryForward
    accrualDate
    maxOpenApplications
    workSaturday
    createdDate
    createdBy
    updatedDate
    updatedBy
    maxDays
    isActive
  }
}`;
export const LeaveApprovers = `{
    leaveApprovers {
        id
        userId
        companyId
        isActive
        status
        statusDescription
       
        branchId
        regionId
      
        leaveType
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}`;
export const allLeaveTypes = `{
    allLeaveTypes {
        id
        type
      
    }
}`;
export const allRecurringStatus = `{
    allRecurringTypes {
        id
        type
        
    }
}
`;
export const allUsers = `
{
    allUsers {
        id
        firstName
        lastName
        email
        phone
        username
        
    }
}
`;
export const leaveApplicationsByUser = ` {
    leaveApplicationsByUser {
        id
        userId
        companyId
        leaveTypeId
        startDate
        endDate
        resumptionDate
        isActive
        status
        statusDescription
        genderId
        branchId
        regionId
        gender
        leaveType
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}`;

export const staffClaimApplications = `{
    staffClaimApplications {
        id
        userId
        companyId
        disbursementTypeId
        disbursementType
        title
        description
        isActive
        declinerCount
        approverCount
        caseId
        caseRelated
        status
        statusDescription
        branchId
        totalAmount
        regionId
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}
`;
export const staffClaimApplicationsByUser = `{
    staffClaimApplicationsByUser {
        id
        userId
        companyId
        disbursementTypeId
        disbursementType
        title
        description
        isActive
        declinerCount
        approverCount
        caseId
        caseRelated
        status
        statusDescription
        branchId
        regionId
        totalAmount
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}`;
export const imprestApplications = `{
    imprestApplications {
        id
        userId
        companyId
        disbursementTypeId
        disbursementType
        title
        description
        isActive
        declinerCount
        approverCount
        caseId
        caseRelated
        status
        statusDescription
        branchId
        regionId
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}`;
export const imprestApplicationsByUser = `{
    imprestApplicationsByUser {
        id
        amount
        userId
        companyId
        disbursementTypeId
        disbursementType
        title
        description
        isActive
        declinerCount
        approverCount
        caseId
        caseRelated
        status
        statusDescription
        branchId
        regionId
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}
`;
export const requisitionApprovers = `{
    requisitionApprovers {
        id
        userId
        companyId
        isActive
        status
        statusDescription
        branchId
        regionId
        leaveType
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}
`;
export const userFinanceDetails = ` {
    userFinanceDetails {
        id
        userId
        companyId
        bankId
        branchId
        bankBranch
        bank
        accountNumber
        mpesaNumber
    }
}
`;
export const allImprestSurrender = ` {
    allImprestSurrender {
        id
        applicationId
        userId
        autoStaffClaim
        totalAmount
        companyId
        disbursementTypeId
        disbursementType
        title
         remainingAmount
        actualSpent
        description
        isActive
        declinerCount
        approverCount
        caseId
        caseRelated
        status
        statusDescription
        branchId
        regionId
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}
`;
export const allDisbursementType = `{
    allDisbursementTypes {
        id
        type
        createdDate
        createdBy
        updatedDate
        updatedBy
    }
}`;
export const employeeLeaveBalances = ` {
    employeeLeaveBalances {
        id
        userId
        companyId
        leaveTypeId
        balance
        isActive
        leaveType
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
    }
}
`;
export const companyCalendarSetups = ` {
    companyCalendarSetups {
        id
        companyId
        recurringTypeId
        recurringType
        holiday
        isActive
        holidayDate
        createdDate
        createdBy
        updatedDate
        updatedBy
    }
}`;
export const allRelievers = `

{
    relievers {
        id
        firstName
        lastName
        email
        phone
        username
        idno
        roleId
        roleName
        isActive
        lastLogin
        loginAttempts
        firstTimeLogin
        changePassword
        hashedPassword
        createdBy
        createdDate
        companyId
        company
        regionId
        region
        branchId
        branch
        titleId
        title
        genderId
        gender
        countryId
        country
        countyId
        county
        roleGroupId
        roleGroup
        departmentId
        department
        employeePaymentTypeId
        employeePaymentType
        updatedBy
        updatedDate
        deactivateBy
        deactivateDate
        approvedBy
        approvedDate
        registrationStatus
        isSupervisor
    }
}`;
export const imprestApllicationForSurrender = ` {
    imprestApplicationsForSurrender {
        id
        userId
        amount
        companyId
        disbursementTypeId
        disbursementType
        title
        description
        isActive
        declinerCount
        approverCount
        caseId
        caseRelated
        status
        statusDescription
        branchId
        regionId
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}
`;
export const pettyCashApplications = `
 {
    pcApplications {
        id
        userId
        amount
        companyId
        disbursementTypeId
        disbursementType
        title
        description
        isActive
        declinerCount
        approverCount
        caseId
        caseRelated
        status
        statusDescription
        branchId
        regionId
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}
`;
export const pettyCashApplicationsByUser = `
 {
    pcApplicationsByUser {
        id
        userId
        amount
        companyId
        disbursementTypeId
        disbursementType
        title
        description
        isActive
        declinerCount
        approverCount
        caseId
        caseRelated
        status
        statusDescription
        branchId
        regionId
        firstName
        lastName
        phoneNumber
        email
        role
        roleGroup
        branch
        region
    }
}

`;
export const NSSFContributionMethods = `
 {
    NSSFContributionMethods {
        id
        methodName
        description
        createdBy
        createdDate
        updatedBy
        updatedDate
    }
}

`;

